import React from "react";

function formatPercent(value) {
    if (value === null || value === undefined) {
        return "–";
    }
    return `${(value * 100).toFixed(1)} %`;
}

function formatNumber(value) {
    if (value === null || value === undefined) {
        return "–";
    }
    return value.toLocaleString("de-DE");
}

export default function LogAggregations({ endpointMetrics, correlationMetrics, isLoading }) {
    const hasData = (endpointMetrics?.length || 0) > 0 || (correlationMetrics?.length || 0) > 0;

    if (!hasData && isLoading) {
        return (
            <div className="rounded-xl border border-slate-200 bg-white p-5 text-center text-sm text-slate-500 shadow-sm">
                Aggregationen werden geladen ...
            </div>
        );
    }

    if (!hasData) {
        return (
            <div className="rounded-xl border border-dashed border-slate-200 p-5 text-center text-sm text-slate-500">
                Für den ausgewählten Zeitraum liegen keine aggregierten Daten vor.
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
                <div className="border-b border-slate-200 px-4 py-3">
                    <h3 className="text-sm font-semibold text-slate-700">Requests pro Endpoint</h3>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-slate-200 text-sm">
                        <thead className="bg-slate-50">
                            <tr>
                                <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Endpoint</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Anfragen</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Fehlerquote</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Ø Dauer</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Max</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200">
                            {(endpointMetrics || []).slice(0, 10).map((metric) => (
                                <tr key={`${metric.method}-${metric.path}`}>
                                    <td className="px-3 py-2 text-slate-600">
                                        <span className="mr-2 rounded bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
                                            {metric.method}
                                        </span>
                                        {metric.path}
                                    </td>
                                    <td className="px-3 py-2 text-right text-slate-600">{formatNumber(metric.totalRequests)}</td>
                                    <td className="px-3 py-2 text-right text-slate-600">{formatPercent(metric.errorRate)}</td>
                                    <td className="px-3 py-2 text-right text-slate-600">
                                        {metric.averageDurationMs ? `${Math.round(metric.averageDurationMs)} ms` : "–"}
                                    </td>
                                    <td className="px-3 py-2 text-right text-slate-600">
                                        {metric.maxDurationMs != null ? `${metric.maxDurationMs} ms` : "–"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
                <div className="border-b border-slate-200 px-4 py-3">
                    <h3 className="text-sm font-semibold text-slate-700">Top-Correlations nach Fehlerquote</h3>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-slate-200 text-sm">
                        <thead className="bg-slate-50">
                            <tr>
                                <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-600">Correlation ID</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Events</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Fehlerquote</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Ø Dauer</th>
                                <th className="px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-600">Letztes Event</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200">
                            {(correlationMetrics || [])
                                .slice()
                                .sort((a, b) => b.errorRate - a.errorRate)
                                .slice(0, 10)
                                .map((metric) => (
                                    <tr key={metric.correlationId}>
                                        <td className="px-3 py-2 text-slate-600">{metric.correlationId}</td>
                                        <td className="px-3 py-2 text-right text-slate-600">{formatNumber(metric.totalEvents)}</td>
                                        <td className="px-3 py-2 text-right text-slate-600">{formatPercent(metric.errorRate)}</td>
                                        <td className="px-3 py-2 text-right text-slate-600">
                                            {metric.averageDurationMs ? `${Math.round(metric.averageDurationMs)} ms` : "–"}
                                        </td>
                                        <td className="px-3 py-2 text-right text-slate-600">
                                            {metric.lastSeen ? new Date(metric.lastSeen).toLocaleString("de-DE") : "–"}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
